import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {AuthenticateService} from '../services/authenticate.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

    private currentUser: any = {};
    public danger = 0;
    tfa: any = {};
    tfaUser: any = {};
    authcode;
    errorMessage;
    @ViewChild('openAuthModal') openAuthModal: ElementRef;
    constructor(private router: Router,
                private authenticateService: AuthenticateService) {
        if (localStorage.getItem('user') != null) {
            this.router.navigate(['/dashboard']);
        }
    }

    ngOnInit() {
    }

    loginAdmin(username, password) {
        const data = {username: username, password: password, source: 'admin'};
        this.authenticateService.login(data).subscribe(res => {
            this.currentUser = JSON.parse(localStorage.getItem('user'));
            if (this.currentUser) {
                this.router.navigate(['/dashboard']);
            }
        }, error => {
            if (error.status === 404) {
                this.danger++;
            }
        });
    }

    loginAdminWithTfa(username, password) {
        const data = {username: username, password: password, source: 'admin'};
        this.tfaUser = data;
        this.authenticateService.loginWithTfa(data).subscribe(res => {
            if (res.tfa) {
                this.tfa = res.tfa;
                this.errorMessage = '';
                this.openAuthModal.nativeElement.click();
            } else {
                this.currentUser = JSON.parse(localStorage.getItem('user'));
                if (this.currentUser) {
                    this.router.navigate(['/dashboard']);
                }
            }
        }, error => {
            if (error.status === 404) {
                this.danger++;
            }
        });
    }

    confirm() {
        this.errorMessage = '';
        this.authenticateService.verifyAuth(this.tfaUser, this.authcode).subscribe((res) => {
            if (res.status) {
                this.currentUser = JSON.parse(localStorage.getItem('user'));
                if (this.currentUser) {
                    this.openAuthModal.nativeElement.click();
                    this.router.navigate(['/dashboard']);
                }
            } else {
                this.errorMessage = 'Güvenlik Kodu Doğrulanamadı';
            }
        }, error => {
            console.log(error)
            if (error.status === 404) {
                this.danger++;
            }
        });
    }

    disabledTfa() {
    }
}



// WEBPACK FOOTER //
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/login/login.component.ts